/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./theme/theme";
import "./styles.css";
import { BrowserRouter } from "react-router-dom";
import CartContextProvider from "./context/cartContext.context";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CartContextProvider>
          <CssBaseline />
          <App />
        </CartContextProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
